import { List } from '../List'

export class EmployeeParent extends List {
  constructor(obj) {
    super(Employee, obj)
  }
}

export class Employee {
  constructor(obj) {
    this.id = obj?.id || null
    this.login = obj?.login || null
    this.isActual = obj?.isActual || false
    this.firstName = obj?.firstName || null
    this.lastName = obj?.lastName || null
    this.middleName = obj?.middleName || null
    this.academicDegree = obj?.academicDegree || null
    this.mech = obj?.mech || null
    this.positions = obj?.positions || []
    this.spin = obj?.spin || null
    this.author = obj?.author || null
    this.orcid = obj?.orcid || null
    this.scopusID = obj?.scopusID || null
    this.hirshIndexRsci = obj?.hirshIndexRsci || null
    this.hirshIndexScopus = obj?.hirshIndexScopus || null
    this.hirshIndexWebOfScience = obj?.hirshIndexWebOfScience || null
  }

  get fullName() {
    return [this?.lastName?.trim() || '', this?.firstName?.trim() || '', this?.middleName?.trim() || '']
      .filter(el => el)
      .join(' ')
  }

  getForAPI() {
    return {
      id: this.id || null,
      login: this.login || null,
      isActual: this.isActual || false,
      firstName: this.firstName || null,
      lastName: this.lastName || null,
      middleName: this.middleName || null,
      academicDegree: this.academicDegree || null,
      mech: this.mech || null,
      positions: this.positions || [],
      spin: this.spin || null,
      author: this.author || null,
      orcid: this.orcid || null,
      scopusID: this.scopusID || null,
      hirshIndexRsci: this.hirshIndexRsci || null,
      hirshIndexScopus: this.hirshIndexScopus || null,
      hirshIndexWebOfScience: this.hirshIndexWebOfScience || null,
      fullName: this.fullName || null
    }
  }

  static buildFromAPI(obj) {
    const _this = new Employee()
    if (obj) {
      _this.id = obj?.id || null
      _this.login = obj?.login || null
      _this.isActual = obj?.isActual || false
      _this.firstName = obj?.firstName || null
      _this.lastName = obj?.lastName || null
      _this.middleName = obj?.middleName || null
      _this.academicDegree = obj?.academicDegree || null
      _this.mech = obj?.mech || null
      _this.positions = obj?.positions || []
      _this.spin = obj?.spin || null
      _this.author = obj?.author || null
      _this.orcid = obj?.orcid || null
      _this.scopusID = obj?.scopusID || null
      _this.hirshIndexRsci = obj?.hirshIndexRsci || null
      _this.hirshIndexScopus = obj?.hirshIndexScopus || null
      _this.hirshIndexWebOfScience = obj?.hirshIndexWebOfScience || null
    }
    return _this
  }
}
